import {useEffect} from 'react'
import {signoutRedirectCallback} from '../../Authorization/authService'
import {useHistory} from 'react-router-dom'
import LoadingIndicator from '../Loading/index'

const SignoutOidc = () => {
  const history = useHistory()
  useEffect(() => {
    async function signoutAsync() {
      await signoutRedirectCallback()
      history.push('/')
    }

    signoutAsync()
  }, [history])

  return (
      <LoadingIndicator props={true}/>
  )
}

export default SignoutOidc
